// Mind2Magic CRM — History & Undo/Redo Module
// Extracted from index.html Step 6.
// Manages undo/redo stacks, historial (audit trail), and state snapshots.

import { STAGES, MAX_HISTORY, HISTORIAL_TIPOS, _HISTORIAL_FIELD_LABELS } from './constants.js'
import { store } from './store.js'

// ========== UNDO / REDO ==========

let undoStack = []
let redoStack = []

function saveState(action = 'cambio') {
    const { leads, clients, historico } = store
    const state = {
        leads: JSON.parse(JSON.stringify(leads)),
        clients: JSON.parse(JSON.stringify(clients)),
        historico: JSON.parse(JSON.stringify(historico)),
        action,
        timestamp: new Date()
    }
    undoStack.push(state)
    if (undoStack.length > MAX_HISTORY) undoStack.shift()
    redoStack = []
    updateUndoRedoButtons()
}

function undo() {
    if (undoStack.length === 0) return
    const { leads, clients, historico } = store
    redoStack.push({
        leads: JSON.parse(JSON.stringify(leads)),
        clients: JSON.parse(JSON.stringify(clients)),
        historico: JSON.parse(JSON.stringify(historico)),
        action: 'redo',
        timestamp: new Date()
    })
    const prev = undoStack.pop()
    store.leads = prev.leads
    store.clients = prev.clients
    store.historico = prev.historico
    window.renderAll()
    window.toast(`↩️ Deshacer: ${prev.action}`, 'success')
    updateUndoRedoButtons()
    if (window.supabaseDB?.isConnected()) {
        window.syncBulkImportToSupabase()
    }
}

function redo() {
    if (redoStack.length === 0) return
    const { leads, clients, historico } = store
    undoStack.push({
        leads: JSON.parse(JSON.stringify(leads)),
        clients: JSON.parse(JSON.stringify(clients)),
        historico: JSON.parse(JSON.stringify(historico)),
        action: 'undo',
        timestamp: new Date()
    })
    const next = redoStack.pop()
    store.leads = next.leads
    store.clients = next.clients
    store.historico = next.historico
    window.renderAll()
    window.toast(`↪️ Rehacer`, 'success')
    updateUndoRedoButtons()
}

function updateUndoRedoButtons() {
    const undoBtn = document.getElementById('undoBtn')
    const redoBtn = document.getElementById('redoBtn')
    if (undoBtn) undoBtn.disabled = undoStack.length === 0
    if (redoBtn) redoBtn.disabled = redoStack.length === 0
}


// ========== HISTORIAL DE CAMBIOS (AUDIT TRAIL) ==========

function addHistorial(lead, tipo, desc, cambios = null) {
    if (!lead) return
    if (!lead.formData || typeof lead.formData !== 'object') lead.formData = {}
    if (!Array.isArray(lead.formData._historial)) lead.formData._historial = []
    const entry = { ts: new Date().toISOString(), tipo, desc }
    if (cambios && Object.keys(cambios).length > 0) entry.cambios = cambios
    lead.formData._historial.unshift(entry)
    if (lead.formData._historial.length > 100) lead.formData._historial.length = 100
}

function _buildCambios(oldSnap, lead, fields) {
    const cambios = {}
    for (const f of fields) {
        const antes = oldSnap[f] ?? null
        const despues = lead[f] ?? null
        if (String(antes) !== String(despues)) {
            cambios[f] = { antes, despues }
        }
    }
    return cambios
}

function _snapLead(l) {
    return {
        titular: l.titular, contacto: l.contacto, phone: l.phone, email: l.email,
        type: l.type, destination: l.destination, travelDate: l.travelDate, travelEnd: l.travelEnd,
        totalVenta: l.totalVenta, commission: l.commission, commission70: l.commission70,
        abono: l.abono, abonado: l.abonado, fechaAbono: l.fechaAbono, fechaPagoFinal: l.fechaPagoFinal,
        stage: l.stage, responsable: l.responsable, reservationNum: l.reservationNum,
        diasParque: l.diasParque, tipoParque: l.tipoParque, tickets: l.tickets,
        parkHopper: l.parkHopper, hasDiningPlan: l.hasDiningPlan, hotel: l.hotel,
        platform: l.platform, viajeros: l.viajeros,
        hotels: l.hotels ? JSON.parse(JSON.stringify(l.hotels)) : null,
        parkEntries: l.parkEntries ? JSON.parse(JSON.stringify(l.parkEntries)) : null,
    }
}

function showHistorialModal(leadId) {
    const { leads, historico } = store
    const l = leads.find(x => x.id === leadId) || historico.find(x => x.id === leadId)
    if (!l) return
    const hist = l.formData?._historial || []

    document.getElementById('historialOverlay')?.remove()

    const overlay = document.createElement('div')
    overlay.className = 'historial-overlay'
    overlay.id = 'historialOverlay'
    overlay.onclick = e => { if (e.target === overlay) overlay.remove() }

    const formatTs = (ts) => {
        const d = new Date(ts)
        const now = new Date()
        const diff = Math.floor((now - d) / 60000)
        if (diff < 1) return 'Ahora mismo'
        if (diff < 60) return `Hace ${diff} min`
        if (diff < 1440) return `Hace ${Math.floor(diff / 60)}h`
        return d.toLocaleDateString('es-CO', { day: 'numeric', month: 'short', year: d.getFullYear() !== now.getFullYear() ? 'numeric' : undefined }) + ' ' + d.toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' })
    }

    const fmtVal = (v) => {
        if (v === null || v === undefined || v === '') return '—'
        if (typeof v === 'boolean') return v ? 'Sí' : 'No'
        return String(v)
    }

    let itemsHtml = ''
    if (hist.length === 0) {
        itemsHtml = '<div class="historial-empty">No hay cambios registrados todavía.</div>'
    } else {
        hist.forEach((h, idx) => {
            const tipoInfo = HISTORIAL_TIPOS[h.tipo] || { label: h.tipo, icon: '📝' }
            let cambiosHtml = ''
            if (h.cambios) {
                cambiosHtml = '<div class="historial-cambios">'
                for (const [field, { antes, despues }] of Object.entries(h.cambios)) {
                    const label = _HISTORIAL_FIELD_LABELS[field] || field
                    const fmtStage = (v) => STAGES.find(s => s.id === v)?.name || v
                    const a = field === 'stage' ? fmtStage(antes) : fmtVal(antes)
                    const d = field === 'stage' ? fmtStage(despues) : fmtVal(despues)
                    cambiosHtml += `<div class="historial-cambio"><span class="historial-field">${window.escHtml(label)}</span><span class="historial-antes">${window.escHtml(a)}</span><span class="historial-arrow">→</span><span class="historial-despues">${window.escHtml(d)}</span></div>`
                }
                cambiosHtml += '</div>'
            }
            const canRevert = h.cambios && Object.keys(h.cambios).length > 0 && idx < 10
            itemsHtml += `
                <div class="historial-item tipo-${h.tipo}">
                    <div class="historial-meta">
                        <span class="historial-tipo">${tipoInfo.icon} ${window.escHtml(tipoInfo.label)}</span>
                        <span class="historial-ts">${formatTs(h.ts)}</span>
                    </div>
                    <div class="historial-desc">${window.escHtml(h.desc)}</div>
                    ${cambiosHtml}
                    ${canRevert ? `<button class="historial-revert" onclick="revertHistorial('${leadId}', ${idx})">↩ Revertir este cambio</button>` : ''}
                </div>`
        })
    }

    overlay.innerHTML = `
        <div class="historial-modal">
            <div class="historial-header">
                <h3>📋 Historial — ${window.escHtml(l.titular)}</h3>
                <button class="modal-close" onclick="document.getElementById('historialOverlay').remove()">✕</button>
            </div>
            <div class="historial-body">
                ${itemsHtml}
            </div>
        </div>`
    document.body.appendChild(overlay)
}

function revertHistorial(leadId, idx) {
    const { leads } = store
    const l = leads.find(x => x.id === leadId)
    if (!l || !l.formData?._historial?.[idx]?.cambios) return

    const entry = l.formData._historial[idx]
    const cambios = entry.cambios
    if (!confirm(`¿Revertir "${entry.desc}"? Los campos volverán a su valor anterior.`)) return

    saveState('revertir historial')

    const revertCambios = {}
    for (const [field, { antes }] of Object.entries(cambios)) {
        revertCambios[field] = { antes: l[field], despues: antes }
        l[field] = antes
    }

    if (cambios.stage) l.progress = window.calcProgress(l.stage)

    const { clients } = store
    const c = clients[l.clientKey]
    if (c) {
        const t = c.trips.find(t => t.id === leadId)
        if (t) {
            for (const field of Object.keys(cambios)) {
                if (field in t) t[field] = l[field]
            }
            if (cambios.stage) t.progress = l.progress
        }
    }

    addHistorial(l, 'edicion', `Revertido: ${entry.desc}`, revertCambios)
    window.syncLeadToSupabase(l)
    window.renderAll()
    window.toast('Cambio revertido', 'success')
    showHistorialModal(leadId)
}

// Register on window for inline module and HTML handlers
Object.assign(window, {
    saveState, undo, redo, updateUndoRedoButtons,
    addHistorial, _buildCambios, _snapLead,
    showHistorialModal, revertHistorial,
})
